// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the popup is positioned absolutely or fixed */
.notification-popup {
  position: absolute;
  top:40px;
  right: -70px; /* Position below the bell icon */

  z-index: 1000; /* Ensure it appears above other elements */
  background-color: var(--color-dark);
  border: 1px solid hsl(164, 15%, 24%);
 
  min-width: 300px;
}

.text-notification {
  color: hsl(159, 100%, 51%);
}`, "",{"version":3,"sources":["webpack://./src/components/Header/popupNotification.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAE,iCAAiC;;EAE/C,aAAa,EAAE,2CAA2C;EAC1D,mCAAmC;EACnC,oCAAoC;;EAEpC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Ensure the popup is positioned absolutely or fixed */\r\n.notification-popup {\r\n  position: absolute;\r\n  top:40px;\r\n  right: -70px; /* Position below the bell icon */\r\n\r\n  z-index: 1000; /* Ensure it appears above other elements */\r\n  background-color: var(--color-dark);\r\n  border: 1px solid hsl(164, 15%, 24%);\r\n \r\n  min-width: 300px;\r\n}\r\n\r\n.text-notification {\r\n  color: hsl(159, 100%, 51%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
